<h3>{{ (customVariables$ | async)?.discover_popup_description }}</h3>

<div class="continue-button-container">
  <button mat-raised-button (click)="closeDialog(buttonTypes.NEXT)">
    <span [translate]="'OnBoardingPopup:NextTime'">Next time</span>
  </button>
  <button mat-raised-button color="primary" (click)="closeDialog(buttonTypes.DISCOVER)">
    <span [translate]="'OnBoardingPopup:DiscoverCTA'">Discover now</span>
  </button>
</div>
